import React from "react";
import moment from "moment";
import DataGrid, { Column, HeaderFilter, Paging, Pager } from "devextreme-react/ui/data-grid";
import validaciones from "../../../../../../helpers/validaciones";
// import NoDataComponent from "../../../../../Shared/noDataImage";


class TablaAtencionesMedicas extends React.PureComponent {
  render() {
    return (
      <DataGrid
        // className="tabla-siniestros"
        className="custom-table height-min cursor-disabled"
        // ref={(ref) => { if (ref !== null) this.tableRef = ref.instance; }}
        showBorders={false}
        showColumnLines={false}
        showRowLines={false}
        renderAsync
        noDataText=""
        rowAlternationEnabled
        dataSource={this.props.data}
        onContentReady={(e) => {
          if (e.component.totalCount() === 0) {
            const config = {};
            config.addClass = "table-margin";
            const noDataSpan = e.component.element().querySelector(".dx-datagrid-nodata");
            const element = validaciones.noDataDOMElement(config, "Sin atenciones médicas");
            noDataSpan.appendChild(element);
          }
        }}
      >
        <HeaderFilter
          visible
          texts={{
            cancel: "Cancelar",
            emptyValue: "Sin valor",
            ok: "Aceptar",
          }}
        />
        <Column caption="Estado Atención" dataField="EstadoAtencion" allowFiltering={false} />
        <Column
          caption="Tipo Atención Médica"
          dataField="TipoAtencionMedica"
          allowFiltering={false}
          cellComponent={(row) =>
            (<div>
              {row.data.TipoAtencionMedica}
              {row.data.TipoAtencionMedica === "Control" &&
                <span className="table-label-light-blue">
                  {row.data.Transporte}
                </span>
              }
             </div>)
          }
        />
        <Column
          dataField="FechaAtencion"
          caption="Fecha Atención"
          sortIndex={0}
          sortOrder="desc"
          sortingMethod={(v1, v2) => {
            const v1d = moment(v1);
            const v2d = moment(v2);
            if (v1d.isAfter(v2d)) return 1;
            if (v1d.isSame(v2d)) return 0;
            if (v1d.isBefore(v2d)) return -1;
            return 0;
          }}
          dataType="date"
          format="dd/MM/yyyy"
          allowFiltering={false}
        />
        <Column dataField="LugarAtencion" caption="Lugar Atención" allowFiltering={false} />
        <Column dataField="HoraAtencion" caption="Hora Atención" dataType="date" format="HH:mm" allowFiltering={false} />
        <Paging pageSize={10} enabled />
        <Pager showNavigationButtons showInfo infoText={(page, total) => `Página ${page} de ${total}`} />
      </DataGrid>
    );
  }
}

export default TablaAtencionesMedicas;
